import { gql } from '@apollo/client';

export const GET_ORG_NAME = gql`
  query GetOrgName {
    orgName
    orgLogo
    orgDateDeactivated
    vm {
      applicationsClosed
    }
  }
`;
